import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useDeviceType } from 'hooks/useDeviceType';
import { borrowerProfileAPI } from 'redux_store/services/borrower-profile';
import { applicationAPI } from 'redux_store/services/client/profile';
import { mapChangedFieldsToSections, normalizeSections } from 'utils/aiFieldSections';
import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';

const ResponsiveLayout = ({ children }) => {
  const { isMobile } = useDeviceType();
  const dispatch = useDispatch();

  // Global listener: auto-refresh cached data when AI mutates borrower/application data
  useEffect(() => {
    const handler = (event) => {
      const detail = event?.detail || {};
      const userRole = detail?.user_role;
      const isConsumerContext = userRole === 'consumer';
      const changedFields = Array.isArray(detail?.changed_fields)
        ? detail.changed_fields
        : [];
      const sections = normalizeSections(
        detail?.sections?.length ? detail.sections : mapChangedFieldsToSections(changedFields)
      );
      const hasScopedSection = sections.some((section) => section !== 'unknown');

      if (hasScopedSection) {
        window.dispatchEvent(
          new CustomEvent('ai-section-updated', {
            detail: {
              ...detail,
              sections,
              changed_fields: changedFields,
            },
          })
        );
        return;
      }

      if (!isConsumerContext) {
        dispatch(borrowerProfileAPI.util.invalidateTags(['getApplication']));
      }
      dispatch(applicationAPI.util.invalidateTags(['getApplication']));
    };
    window.addEventListener('ai-data-updated', handler);
    return () => window.removeEventListener('ai-data-updated', handler);
  }, [dispatch]);

  if (isMobile) {
    return <MobileLayout>{children}</MobileLayout>;
  }

  return <DesktopLayout>{children}</DesktopLayout>;
};

export default ResponsiveLayout;
